import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BillingserviceService } from 'app/billing/billingService.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { SurgicalHistoryModel } from 'app/EMR/HistoryModels/surgicalhistory.model';
import { HelplistService } from 'app/helplist.service';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-search-new-surgery',
  templateUrl: './search-new-surgery.component.html',
  styleUrls: ['./search-new-surgery.component.scss']
})
export class SearchNewSurgeryComponent implements OnInit {
  showspinner:boolean=false;
  filterTerm: any;
  getSerguryArray: any = [];
  displayedColumns: string[] = ['surgerycode','surgeryname','shortname','surgeryCatName','SurgeryDeptName','operationType','isActive'];
  // dataSource_Sur = new MatTableDataSource<SurgicalHistoryModel>();
  constructor(public service : VoiceRecognitionService,private exportdata: ExportService, public emrservice: EMRService, public billingservice:BillingserviceService, public helplistservice:HelplistService, public dashboardService:DashboardService,
    public dialogRef: MatDialogRef<SearchNewSurgeryComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) {
      dialogRef.disableClose = true; 
      this.service.init()
    }

  ngOnInit(): void {
    this.service.Newtext='';
  //  this.dataSource_Sur.data = this.helplistservice.surgeryList.slice();
   // this.filterTerm =this.service.text;
  this.getAllSergury();
  }
  originalSurgeryList: any[] = [];
   getAllSergury(){
    this.showspinner=true;
    this.emrservice.GetSurgeryAll(0,'A').subscribe((item: any) => {
       this.originalSurgeryList = item;
       console.log(this.originalSurgeryList,'called list')
      this.getSerguryArray = item;
      this.showspinner=false;
    },err=>{
      this.showspinner=false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
   }
  startService(){
    this.service.start('NewSurgery Search')
  }

  stopService(){
    this.service.stop('NewSurgery Search')
    //  if(this.service.Newtext){
    //   this.filtersurgerydata(this.service.Newtext);
    //  }
  }
  // applyFilter_grid(filterValue){
  //   this.dataSource_Sur.filter = filterValue.trim().toLowerCase();
  
  // }
  closedialog() {
    this.stopService();
    this.service.Newtext='';
    this.dialogRef.close(0);
    this.getSerguryArray =null;
  }
  // filtersurgerydata(event){
  //   const finddata=this.filerdata(this.helplistservice.surgeryList.slice(),event);
  //   if(finddata.length >0){
  //     this.getSerguryArray =finddata;
  //   }else{
  //    if(event !=null && event !=''){
  //      var pdata= event
  //    }else{
  //       pdata =0;
  //    }
  //    this.emrservice.GetSurgeryAll(pdata,0).subscribe((item:any)=>{
  //     this.getSerguryArray =item;
  //    })
  //   }
  //  }
  filterSurgeryList() {
  const searchText = this.service.Newtext?.toLowerCase() || '';

  if (!searchText) {
    this.getSerguryArray = [...this.originalSurgeryList];
    return;
  }

  this.getSerguryArray = this.originalSurgeryList.filter(item => {
    return (
      item.surgeryName?.toLowerCase().includes(searchText) ||
      item.surgeryCode?.toLowerCase().includes(searchText) ||
      item.shortName?.toLowerCase().includes(searchText) ||
      item.surgeryCatName?.toLowerCase().includes(searchText) ||
      item.surgeryDeptName?.toLowerCase().includes(searchText) ||
      this.searchSergeryCatName(item.fkSurgeryCatId)?.toLowerCase().includes(searchText) ||
      item.operationTypeName?.toLowerCase().includes(searchText)
    );
  });
  console.log(this.getSerguryArray,'called list')
}

   filerdata(items: any[], searchText: string){ 
       return items ? items.filter(item => item.surgeryName.search(new RegExp(searchText, 'i')) > -1) : [];
   
   }
 
 
 
      selectRow(row) { 
        this.dialogRef.close(row);
        this.stopService();
        // this.service.text='';
      }

      searchSergeryCatName(categoryid){

        const categoryname= this.helplistservice.categories.filter(item=>item.pkSurgeryCatId ==categoryid);

        return categoryname[0].surgeryCatName;
       
      }
      exportexcel(): void {
        this.exportdata.open_loader_Dialogtwo();
        let element = document.getElementById('sugerycontent');
        this.exportdata.Newexportxcel(element, 'Surgery Master List');
    
      }
}
